import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {AppStateService} from "./app-state.service";
import {Subscription} from "rxjs";

@Pipe({name: 'nameFormat', pure: false})
export class NameFormatPipe implements PipeTransform, OnDestroy {

  private value: PersonName;
  private computed: string;
  private locale: string;
  private subscription: Subscription;

  constructor(private Change: ChangeDetectorRef,
              private AppState: AppStateService) {
  }

  transform(value: PersonName): string {
    if (!this.subscription) {
      this.subscription = this.AppState.locale$.subscribe(locale => {
        this.locale = locale;
        this.computed = null;
        this.Change.markForCheck();
      });
    }
    if (value === this.value && this.computed) {
      return this.computed;
    }
    return this.computed = NameFormatPipe.apply(this.value = value, this.AppState.locale$.getValue());
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  static apply(value: PersonName, locale: string): string {
    if (!value) return '';
    if (locale && locale.startsWith('ja')) {
      return value.lastName + ' ' + value.firstName;
    } else if (value.hasOwnProperty('preferredName') && value.preferredName !== null) {
      return value.preferredName; 
    } else {
      return value.firstName + ' ' + value.lastName;
    }
  }
}
